import moment from 'moment';

export default function today() {
  return moment().startOf('day').toDate();
}
